import { REQUEST_FEATURES, RECEIVE_FEATURES } from '../constants/actionTypes';

export function reqFeatures(flagNames) {
  return {
    type: REQUEST_FEATURES,
    flagNames,
  };
}

export function receiveFeatures(featureKeys, values) {
  return {
    type: RECEIVE_FEATURES,
    keys: featureKeys,
    values,
  };
}
